<p>Please let us know your school and role</p>

<form [formGroup]="demographicsForm" (submit)="SaveDemographics()">
    <div class="form-group">
        <label for="schoolName">School Name</label>
        <input class="form-control" id="schoolName" formControlName="schoolName" type="text" required />
    </div>

    <div class="form-group">
        <label for="schoolRole">Your Role</label>
        <select [bs3Class]="['form-control']" [bs4Class]="['form-select']" id="schoolRole" formControlName="schoolRole" required>
            <option *ngFor="let role of schoolRoles" [value]="role">{{role}}</option>
        </select>
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-lg" type="submit" [disabled]="!demographicsForm.valid || (Busy$ | async)">Save</button>
    </div>
</form>